export const SIGN_IN_USER = "SIGN_IN_USER";
export const GET_USER_LIST = "GET_USER_LIST";
export const GET_USER = "GET_USER";
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";

export const GET_INVOICE_LIST = "GET_INVOICE_LIST";
export const ADD_INVOICE = "ADD_INVOICE";
export const DELETE_INVOICE = "DELETE_INVOICE";
export const INVOICE_TOTAL = "INVOICE_TOTAL";
export const INVOICE_ROW_TOTAL = "INVOICE_ROW_TOTAL";

export const GET_DESPATCH_LIST = "GET_DESPATCH_LIST";
export const ADD_DESPATCH = "ADD_DESPATCH";
export const DELETE_DESPATCH = "DELETE_DESPATCH";
export const DESPATCH_TOTAL = "DESPATCH_TOTAL";
export const DESPATCH_ROW_TOTAL = "DESPATCH_ROW_TOTAL";

export const GET_EARCHIVE_LIST = "GET_EARCHIVE_LIST";
export const ADD_EARCHIVE = "ADD_EARCHIVE";
export const DELETE_EARCHIVE = "DELETE_EARCHIVE";
export const EARCHIVE_TOTAL = "EARCHIVE_TOTAL";
export const EARCHIVE_ROW_TOTAL = "EARCHIVE_ROW_TOTAL";

export const GET_EMM_LIST = "GET_EMM_LIST";
export const ADD_EMM = "ADD_EMM";
export const DELETE_EMM = "DELETE_EMM";
export const EMM_TOTAL = "EMM_TOTAL";
export const EMM_ROW_TOTAL = "EMM_ROW_TOTAL";

export const GET_INVOICESERIAL_LIST = "GET_INVOICESERIAL_LIST";
export const ADD_INVOICESERIAL = "ADD_INVOICESERIAL";
export const DELETE_INVOICESERIAL = "DELETE_INVOICESERIAL";

export const ADD_INVOICE_DESIGN = "ADD_INVOICE_DESIGN";
export const GET_INVOICE_DESIGN_LIST = "GET_INVOICE_DESIGN_LIST"; 
export const DELETE_INVOICE_DESIGN = "DELETE_INVOICE_DESIGN";

export const GET_BRANCH_DEFINITION_LIST = "GET_BRANCH_DEFINITION_LIST";
export const ADD_BRANCH_DEFINITION = "ADD_BRANCH_DEFINITION";
export const DELETE_BRANCH_DEFINITION = "DELETE_BRANCH_DEFINITION";

export const GET_OUTENVELOPE_LIST = "GET_OUTENVELOPE_LIST";

export const GET_INCOMING_ENVELEOP_LIST = "GET_BRANCH_DEFINITION_LIST";
export const ADD_INCOMING_ENVELEOP = "ADD_BRANCH_DEFINITION";
export const DELETE_INCOMING_ENVELEOP = "DELETE_BRANCH_DEFINITION";

